import { memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack, Box, HStack } from '@cbhq/cds-web/layout';
import { TextBody, Link } from '@cbhq/cds-web/typography';
import { paletteValueToCssVar } from '@cbhq/cds-web/utils/palette';
import zIndex from '../../../design/themes/zIndex.js';
import FlagIcon from '../../GlobalPreferences/FlagIcon.js';
import { messages } from './messages.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function DesktopBanner({
  countryFromIpConfig,
  countryNameFromUrl,
  countryNameFromIp,
  destination,
  onDismiss
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/jsx(VStack, {
    width: "100%",
    zIndex: zIndex.top,
    dangerouslySetBackground: paletteValueToCssVar('gray5'),
    spacing: 2,
    spacingVertical: 3,
    spacingHorizontal: 2,
    alignItems: "center",
    children: /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      maxWidth: 1180,
      children: [/*#__PURE__*/jsxs(Box, {
        alignSelf: "center",
        children: [/*#__PURE__*/jsx(FlagIcon, {
          countryCode: countryFromIpConfig.country_code,
          size: 24
        }), /*#__PURE__*/jsx(TextBody, {
          as: "span",
          noWrap: true,
          spacingStart: 1,
          children: formatMessage(messages.bannerDescription, {
            countryFromUrl: formatMessage(countryNameFromUrl),
            countryFromIp: formatMessage(countryNameFromIp)
          })
        })]
      }), /*#__PURE__*/jsxs(HStack, {
        gap: 3,
        children: [/*#__PURE__*/jsx(StyledDismiss, {
          color: "foreground",
          onPress: onDismiss,
          children: formatMessage(messages.dismissText)
        }), /*#__PURE__*/jsx(StyledLink, {
          to: destination,
          rel: "nofollow",
          children: /*#__PURE__*/jsxs(HStack, {
            alignItems: "center",
            children: [formatMessage(messages.switchSiteDesktopText, {
              countryFromIp: formatMessage(countryNameFromIp)
            }), /*#__PURE__*/jsx(Icon, {
              name: "forwardArrow",
              size: "s",
              spacingStart: 2
            })]
          })
        })]
      })]
    })
  });
}
const StyledDismiss = styled(Link)`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;
const StyledLink = styled(Link)`
  max-width: 100%;
  align-self: center;
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: pointer;
`;
const DesktopBanner$1 = /*#__PURE__*/memo(DesktopBanner);
export { DesktopBanner$1 as default };
//# sourceMappingURL=DesktopBanner.js.map
